import { API_METHODS, API_URL } from 'common/constants/sm-constants';
import { SmApiService } from 'common/services/core-services/sm-api.service';
import { SystemService } from 'common/services/core-services/system.service';
import { Injectable } from '@angular/core';
import { editInfo } from 'common/models/utility-models/utility-interface';
import { environment } from 'src/environments/environment';
import { FormDataService } from '../base-data-services/form-data.service';
import { MentorFeedbackModel } from 'common/models/page-models/mentor-feedback/mentor-feedback-data-model';
import { MentorFeedbackQuestionsModel } from 'common/models/page-models/mentor-feedback/mentor-feedback-question-data.model';

@Injectable({
  providedIn: 'root',
})
export class MentorFeedbackQuestionsDataService extends FormDataService<MentorFeedbackModel> {
  constructor(apiService: SmApiService, protected override ss: SystemService) {
    super(API_URL.viewMentorFeedbackQuestion, apiService, ss);
  }

  createInstance(): MentorFeedbackModel {
    return new MentorFeedbackModel();
  }

  getEditUrlAndMethod() {
    const edit = {
      url: environment.apiUrl + API_URL.viewMentorFeedbackQuestion,
      method: API_METHODS.post,
    };
    return edit;
  }

  override modifyAPIResponse(response: any) {
    return response['details'];
  }
  override afterPostData(
    model: any,
    result?: any
  ): Promise<MentorFeedbackModel> {
    return new Promise<MentorFeedbackModel>((resolve, reject) => {
      if(result.status === 'Success')
      {
        window.location.reload();
      }
      resolve(this.transformAPIData(model));
    });
  }
  
}